import { clientApi } from 'api';
import { IBlogCover } from 'server/models/BlogCover/types';

export const createOrUpdateBlogCover = (isServer = false) => async (data: FormData) => {
  const response = await clientApi.patch<IBlogCover>(`/blog/cover`, data);

  return response;
};
